import TechnicalIssuesPage from "./pages/TechnicalIssuesPage";

export { TechnicalIssuesPage };

export const technicalIssuesRoutes = [
  {
    path: "/technical-issues",
    element: <TechnicalIssuesPage />,
  },
];
